document.addEventListener("DOMContentLoaded", function () {
  const internalHost = window.location.host; // Gets the current site's host
  document.querySelectorAll("a").forEach(function (link) {
    if (link.host !== internalHost && link.host !== "") {
      link.target = "_blank"; // Set target="_blank" only for external links
    }
  });
});
